import { AxiosPromise } from 'axios';
import { IGetCounsels } from '../models/employeesCounsel.model';
import axios from 'axios';

const uri = '/mgmt/employees/counsel';

export const getStaffCounsels = (memberCode: string): AxiosPromise<IGetCounsels> => {
  return axios.get(`${uri}/${memberCode}`);
}
